module.exports = __webpack_public_path__ + "img/chicagouniversitylogo.cc1526e9.jpg";